import { HOTEL_CFAR_ROUTE } from '../../../router/constants';
import { App } from './App';

export const HOTEL_CFAR = {
  path: HOTEL_CFAR_ROUTE,
  element: <App />,
};
